import React from "react";
import { NewsletterButton } from "../shared";

type SocialLink = {
  name: string;
  href: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
};

type SocialStripProps = {
  links: SocialLink[];
};

const getPlatformFromName = (name: string): string => {
  const lowerName = name.toLowerCase();
  if (lowerName.includes("x") || lowerName.includes("twitter")) return "x";
  if (lowerName.includes("meta") || lowerName.includes("facebook"))
    return "facebook";
  if (lowerName.includes("instagram")) return "instagram";
  if (lowerName.includes("linkedin")) return "linkedin";
  if (lowerName.includes("youtube")) return "youtube";
  return lowerName;
};

export default function SocialStrip({ links }: SocialStripProps): JSX.Element {
  return (
    <div className="bg-onyx py-[13px]" data-content-type="social-strip">
      <ul className="global-container align-center flex justify-end gap-3 text-white">
        {links.map((link, i) => {
          const platform = getPlatformFromName(link.name);
          return (
            <li key={i} className="h-6 w-6">
              <a
                target="_blank"
                href={link.href}
                title={link.name}
                rel="noreferrer"
                data-component-type="social-link"
                data-social-platform={platform}
                data-click-id={`social-strip-${platform}`}
                id={`social-link-${platform}`}
              >
                {link.icon({ "aria-label": link.name })}
              </a>
            </li>
          );
        })}
        <li className="ml-1">
          <NewsletterButton>
            <button
              className="text-[14px]"
              data-component-type="social-link"
              data-social-platform="newsletter"
              data-click-id="social-strip-newsletter"
              id="social-link-newsletter"
            >
              NEWSLETTER
            </button>
          </NewsletterButton>
        </li>
      </ul>
    </div>
  );
}
